<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">Complexidade</div>
      </unicom-coluna>
    </unicom-linha>

    <unicom-linha
      v-for="complexidade in listaComplexidades"
      :key="complexidade.id"
      class="linha-embaixo"
      justificarItem="end"
    >
      <unicom-coluna sm="4" :class="espacamentoMobile">
        <div align="right">{{ complexidade.tipoComplexidade }}</div>
      </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          :value="complexidade.selecionado"
          @input="complexidade.selecionado = !complexidade.selecionado"
        />
      </unicom-coluna>
      <unicom-coluna sm="7" :class="espacamentoMobile"> </unicom-coluna>
    </unicom-linha>
  </unicom-layout-cartao>
</template>

<script>
import ComplexidadeMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/ComplexidadeMixin";

export default {
  name: "CartaoInformacoesComplexidade",
  mixins: [ComplexidadeMixin],
  data() {
    return {};
  },
  methods: {},
  computed: {
    /**
     * Verifica se a tela está no viewport mobile e se estiver, retorna uma classe que da o espaçamento para cima
     */
    espacamentoMobile() {
      return this.$breakpoint.smAndDown ? "mt-4" : "";
    }
  },
  watch: {}
};
</script>

<style scoped>
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
</style>
